import api from './api';

let upload_mode = null;
let upload_mode_request = null;

export const getUploadMode = () => upload_mode;

export const ensureUploadMode = async () => {
  if (upload_mode) return upload_mode;

  if (!upload_mode_request) {
    upload_mode_request = api.get('/oss/mode')
      .then((response) => {
        const mode = response.data?.uploadMode;
        if (mode !== 'local' && mode !== 'oss') {
          throw new Error('服务端返回的上传模式无效');
        }
        upload_mode = mode;
        return mode;
      })
      .catch((error) => {
        upload_mode_request = null;
        throw error;
      });
  }

  return upload_mode_request;
};
